import { mutatorAction } from 'satcheljs';
import { getGroupFolder } from 'owa-group-left-nav-folders-store';

export const setGroupFolderName = mutatorAction(
    'setGroupFolderName',
    function (groupId: string, folderId: string, newDisplayName: string): void {
        let groupFolder = getGroupFolder(groupId, folderId);
        if (groupFolder) {
            groupFolder.DisplayName = newDisplayName;
        }
    }
);
